export const handlePayer = (clientName: string) => {
    localStorage.setItem("client", clientName)

}